<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12" md="7">
          <b-card-title>
            <div class="d-flex flex-column align-items-start gap-2">
              <span>Metric Trends</span>
              <small  class="text-muted mb-0">Area metrics overview and full input distribution</small>
            </div>
          </b-card-title>

          <b-card-body>
            <b-row>
              <b-col cols="12">
                <div class="metrics-grid">
                  <b-card class="metric-card growers-card">
                    <div class="metric-card-inner">
                      <div class="metric-icon growers-icon">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                          <circle cx="8.5" cy="7" r="4" />
                          <path d="M20 8v6" />
                          <path d="M23 11h-6" />
                        </svg>
                      </div>
                      <div class="metric-content">
                        <div class="metric-title">Growers</div>
                        <div class="metric-value">{{ formatNumber(totalGrowers) }}</div>
                      </div>
                    </div>
                  </b-card>

                  <b-card class="metric-card hectares-card">
                    <div class="metric-card-inner">
                      <div class="metric-icon hectares-icon">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M12 22c4-2 7-6 7-11a7 7 0 1 0-14 0c0 5 3 9 7 11Z" />
                          <path d="M12 22V10" />
                        </svg>
                      </div>
                      <div class="metric-content">
                        <div class="metric-title">Hectares</div>
                        <div class="metric-value">{{ formatNumber(totalHectares) }}</div>
                      </div>
                    </div>
                  </b-card>

                  <b-card class="metric-card yield-card">
                    <div class="metric-card-inner">
                      <div class="metric-icon yield-icon">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M3 17l6-6 4 4 7-8" />
                          <path d="M14 7h6v6" />
                        </svg>
                      </div>
                      <div class="metric-content">
                        <div class="metric-title">Est Yield</div>
                        <div class="metric-value">{{ formatNumber(totalYield) }}</div>
                      </div>
                    </div>
                  </b-card>

                  <b-card class="metric-card barns-card">
                    <div class="metric-card-inner">
                      <div class="metric-icon barns-icon">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M3 10.5 12 3l9 7.5" />
                          <path d="M5 9.5V21h14V9.5" />
                        </svg>
                      </div>
                      <div class="metric-content">
                        <div class="metric-title">Barns</div>
                        <div class="metric-value">{{ formatNumber(totalBarns) }}</div>
                        <div class="metric-subtitle">
                          Capacity {{ formatNumber(totalCapacity) }}
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <!-- <b-card class="metric-card capacity-card">
                    <div class="metric-card-inner">
                      <div class="metric-icon capacity-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M12 3v18" />
                          <path d="M7 7h8a4 4 0 0 1 0 8H9a4 4 0 0 0 0 8h8" />
                        </svg>
                      </div>
                      <div class="metric-content">
                        <div class="metric-title">Capacity</div>
                        <div class="metric-value">{{ formatNumber(totalCapacity) }}</div>
                      </div>
                    </div>
                  </b-card> -->
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-col>

        <b-col cols="12" md="5">
          <b-card-title class="d-flex justify-content-between">
            <div class="d-flex align-items-center gap-2">
              <span>Inputs Distribution</span>
            </div>

            <div class="d-flex align-items-center gap-2">
              <span>{{ sortedDistributions.reduce((sum, item) => sum + item.value, 0).toLocaleString() }}</span>
            </div>
          </b-card-title>

          <b-card-body>
            <b-row>
              <b-col cols="12">
                <b-table
                  sticky-header="300px"
                  :items="sortedDistributions.sort((a, b) => a.name.localeCompare(b.name))"
                  :fields="columns"
                  responsive
                  small
                  hover
                  striped
                  :busy="loading"
                >
                  <template #cell(id)="data">
                    {{ data.index + 1 }}
                  </template>

                  <template #cell(quantity)="data">
                    {{ formatNumber(data.item.quantity) }}
                  </template>

                  <template #cell(value)="data">
                    {{ formatNumber(data.item.value) }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BSpinner,
  BAlert,
  BTable,
} from "bootstrap-vue";
import { ref, computed, onMounted, onUnmounted, watch } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import store from "@/store";
import useLineSeriesStoreModule from '@/views/dashboard/ecommerce/useLineSeriesStoreModule'

export default {
  props: {
    location_id: {
        type: Number,
        required: false,
        default: null,
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BSpinner,
    BAlert,
    BTable,
    apexchart: VueApexCharts,
  },

  setup(props, context) {
    const CROMIS_STORE_MODULE_NAME = "cromis-sale_trend";

    if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) {
      store.registerModule(CROMIS_STORE_MODULE_NAME, useLineSeriesStoreModule);
    }

    onUnmounted(() => {
      if (store.hasModule(CROMIS_STORE_MODULE_NAME)) {
        store.unregisterModule(CROMIS_STORE_MODULE_NAME);
      }
    });

    const loading = ref(false);
    const selectedLocationId = ref(null);
    const metricTrends = ref([]);
    const distributions = ref([]);
    const locations = ref([]);

    const columns = ref([
      { key: 'id', label: 'sn', thStyle: { width: "4%" }, thClass: 'text-left', tdClass: 'text-left' },
      { key: 'name', label: 'Input', thStyle: { width: "40%" }, thClass: 'text-left', tdClass: 'text-left'},
      { key: 'quantity', label: 'Qty', thStyle: { width: "25%" }, thClass: 'text-right', tdClass: 'text-right'},
      { key: 'value', label: 'Value', thStyle: { width: "31%" }, thClass: 'text-right', tdClass: 'text-right'},
    ])

    const metricFields = [
      { key: "area", label: "Area" },
      { key: "growers", label: "Growers" },
      { key: "hectares", label: "Hectares" },
      { key: "yield", label: "Est Yield" },
      { key: "barns", label: "Barns" },
      { key: "capacity", label: "Capacity" },
    ];

    const distributionFields = [
      { key: "name", label: "Input" },
      { key: "quantity", label: "Quantity" },
    ];

    const formatNumber = (value) => {
      const num = Number(value || 0);
      return num.toLocaleString(undefined, {
        maximumFractionDigits: 2,
      });
    };

    watch(() => props.location_id, async (newValue, oldValue) =>{
      console.log(oldValue, newValue)
      await loadDashboardData(newValue)
    })

    const totalGrowers = computed(() =>
      metricTrends.value.reduce((sum, item) => sum + (Number(item.growers) || 0), 0)
    );

    const totalHectares = computed(() =>
      metricTrends.value.reduce((sum, item) => sum + (Number(item.hectares) || 0), 0)
    );

    const totalYield = computed(() =>
      metricTrends.value.reduce((sum, item) => sum + (Number(item.yield) || 0), 0)
    );

    const totalBarns = computed(() =>
      metricTrends.value.reduce((sum, item) => sum + (Number(item.barns) || 0), 0)
    );

    const totalCapacity = computed(() =>
      metricTrends.value.reduce((sum, item) => sum + (Number(item.capacity) || 0), 0)
    );

    const sortedDistributions = computed(() => {
      return [...distributions.value]
        .filter((item) => Number(item.quantity) > 0)
        .sort((a, b) => Number(b.quantity) - Number(a.quantity));
    });

    const distributionSeries = computed(() =>
      sortedDistributions.value.map((item) => Number(item.quantity) || 0)
    );

    const distributionChartOptions = computed(() => ({
      chart: {
        type: "donut",
        toolbar: {
          show: true,
        },
      },
      labels: sortedDistributions.value.map((item) => item.name),
      legend: {
        position: "bottom",
        fontSize: "12px",
        horizontalAlign: "center",
      },
      dataLabels: {
        enabled: true,
        formatter(val) {
          return `${val.toFixed(1)}%`;
        },
      },
      tooltip: {
        y: {
          formatter: (val) => formatNumber(val),
        },
      },
      plotOptions: {
        pie: {
          donut: {
            size: "58%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "Total",
                formatter() {
                  const total = distributionSeries.value.reduce(
                    (sum, item) => sum + item,
                    0
                  );
                  return formatNumber(total);
                },
              },
            },
          },
        },
      },
      stroke: {
        width: 2,
        colors: ["#fff"],
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: {
              height: 320,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    }));

    const loadDashboardData = async (locationId) => {
      loading.value = true;

      console.log(locationId)

      try {
        const response = await store.dispatch("cromis-sale_trend/listNew", {
          location_id: locationId,
        });

        const metricData = Array.isArray(response.metricResponse.data)
          ? response.metricResponse.data
          : [];

        const distributionData = Array.isArray(response.distributionResponse.data)
          ? response.distributionResponse.data
          : [];

        metricTrends.value = metricData;
        distributions.value = distributionData;
        locations.value = metricData;
      } catch (error) {
        console.log("got error", error);
        metricTrends.value = [];
        distributions.value = [];
        locations.value = [];
      } finally {
        loading.value = false;
      }
    };

    const onChange = async (event) => {
      const selectedId = event || null;
      await loadDashboardData(selectedId);
    };

    onMounted(async () => {
      await loadDashboardData(null);
    });

    return {
      loading,
      selectedLocationId,
      metricTrends,
      distributions,
      locations,
      metricFields,
      distributionFields,
      totalGrowers,
      totalHectares,
      totalYield,
      totalBarns,
      totalCapacity,
      sortedDistributions,
      columns,
      distributionSeries,
      distributionChartOptions,
      formatNumber,
      onChange,
    };
  },
};
</script>

<style scoped>
.main-card {
  border: none;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.page-header h4 {
  font-weight: 700;
  color: #2f2b3d;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.metric-card,
.distribution-card,
.table-card {
  border: none;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  background: #ffffff;
}

.metric-card {
  min-height: 120px;
}

.metric-card .card-body,
.distribution-card .card-body,
.table-card .card-body {
  padding: 1rem 1.1rem;
}

.metric-card-inner {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.metric-icon {
  width: 60px;
  height: 60px;
  min-width: 60px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.14);
}

.metric-icon svg {
  width: 26px;
  height: 26px;
}

.metric-content {
  flex: 1;
  min-width: 0;
}

.metric-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #6e6b7b;
  margin-bottom: 0.35rem;
}

.metric-value {
  font-size: 1.8rem;
  font-weight: 800;
  color: #2f2b3d;
  line-height: 1.1;
  word-break: break-word;
}

.growers-card {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7ff 100%);
}

.hectares-card {
  background: linear-gradient(135deg, #ffffff 0%, #f2fff7 100%);
}

.yield-card {
  background: linear-gradient(135deg, #ffffff 0%, #fff8f0 100%);
}

.barns-card {
  background: linear-gradient(135deg, #ffffff 0%, #fff3f3 100%);
}

.capacity-card {
  background: linear-gradient(135deg, #ffffff 0%, #f2fcff 100%);
}

.growers-icon {
  background: linear-gradient(135deg, #7367f0, #8f84f8);
}

.hectares-icon {
  background: linear-gradient(135deg, #28c76f, #47d787);
}

.yield-icon {
  background: linear-gradient(135deg, #ff9f43, #ffb86e);
}

.barns-icon {
  background: linear-gradient(135deg, #ea5455, #f27b7c);
}

.capacity-icon {
  background: linear-gradient(135deg, #00cfe8, #42dff1);
}

.distribution-header h5,
.table-title {
  font-weight: 700;
  color: #2f2b3d;
}

.table-title {
  margin-bottom: 1rem;
}

@media (max-width: 1199px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 1rem;
  }
}

@media (max-width: 767px) {
  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .metric-value {
    font-size: 1.45rem;
  }

  .metric-icon {
    width: 52px;
    height: 52px;
    min-width: 52px;
  }
  .metric-subtitle {
  font-size: 0.85rem;
  font-weight: 500;
  color: #6e6b7b;
  margin-top: 4px;
}
}
</style>
